import { render } from "./workpermit.vue?vue&type=template&id=9694e4d0&scoped=true"
import script from "./workpermit.vue?vue&type=script&lang=js"
export * from "./workpermit.vue?vue&type=script&lang=js"

import "./workpermit.vue?vue&type=style&index=0&id=9694e4d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9694e4d0"]])

export default __exports__